import { render, staticRenderFns } from "./khAuthorizationAgreement.vue?vue&type=template&id=44671364&scoped=true"
import script from "./khAuthorizationAgreement.vue?vue&type=script&lang=js"
export * from "./khAuthorizationAgreement.vue?vue&type=script&lang=js"
import style0 from "./khAuthorizationAgreement.vue?vue&type=style&index=0&id=44671364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44671364",
  null
  
)

export default component.exports